import { RootState } from '@kopapro-redux/store';

export const getBonusPointsSetup = (state: RootState) => {
  return state.kopapro.bonusPoints.data || {};
};
